class s extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M5.546 15.168c-.2-.1-.348-.3-.3-.551l.9-5.9h-2.4a.453.453 0 0 1-.4-.2c-.1-.1-.1-.249-.1-.4l1.5-6.5a.49.49 0 0 1 .5-.4h5c.152 0 .3.051.4.2.1.1.1.251.1.4l-.9 3.9h2.4c.2 0 .351.1.451.3.1.151.05.351-.05.551l-6.5 8.5c-.1.1-.25.149-.4.149-.05 0-.15 0-.2-.049Zm3.1-8.451 1-4.5h-4l-1.248 5.5h2.948l-.8 5.151 4.7-6.151h-2.6Z"></path></svg>';
  }
}
const t = "pi-mod-actions";
customElements.get(t) || customElements.define(t, s);
export {
  s as default
};
